import clsx from 'clsx'
import { StringParam, useQueryParams, withDefault } from 'use-query-params'
import { Icon } from '@iconify/react'
import { DomainSelector } from '@pepper/ui'

import Search from '../Search'

import s from './Header.module.css'

type Props = {
  companyId: string
  domainId?: string
  isContentIdeasPage?: boolean
  hasNoDomainsInOrg?: boolean
  onDomainChange?: () => void
}

const Header = ({
  companyId,
  domainId,
  isContentIdeasPage,
  hasNoDomainsInOrg,
  onDomainChange,
}: Props) => {
  const [queryParam] = useQueryParams({
    category_id: withDefault(StringParam, undefined),
    step: withDefault(StringParam, undefined),
  })

  const isGeneratingThemes =
    queryParam.step === 'themes' && !queryParam.category_id

  return (
    <div
      className={clsx(s.wrapper, {
        [s.contentIdeasPage]: isContentIdeasPage,
      })}
    >
      <div className={s.iconWrapper}>
        <Icon icon="lucide:lightbulb" width={16} height={16} />
      </div>
      <div className={s.description}>
        Pepper AI scans through millions of keywords to curate content topics,
        tailored for you!
      </div>
      {hasNoDomainsInOrg && (
        <div className={s.info}>
          <Icon icon="lucide:info" width={14} height={14} />
          <span>Please add a domain to get started</span>
        </div>
      )}
      {isContentIdeasPage && (
        <div className={s.domainSelector}>
          <DomainSelector
            companyId={companyId}
            isControlled={false}
            onChange={onDomainChange}
            disabled={isGeneratingThemes}
          />
        </div>
      )}
      <p className={s.searchTitle}>Enter a category</p>
      <Search
        companyId={companyId}
        domainId={domainId}
        hasNoDomainsInOrg={hasNoDomainsInOrg}
      />
    </div>
  )
}

export default Header
